<template>
    <div>
        <base-nav
            v-model="$topbar.visible"
            class="navbar-absolute top-navbar"
            type="white"
            :transparent="true"
        >
            <div slot="brand" class="navbar-wrapper">
                <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
                <div
                    class="navbar-toggle d-inline"
                    :class="{ toggled: $sidebar.showSidebar }"
                >
                    <button type="button" class="navbar-toggler" @click="toggleSidebar">
                        <span class="navbar-toggler-bar bar1"></span>
                        <span class="navbar-toggler-bar bar2"></span>
                        <span class="navbar-toggler-bar bar3"></span>
                    </button>
                </div>
                <div class="navbar-brand">
                    <span style="font-size:1.2rem">TRAX LRS</span>
                    <span style="font-size:0.8rem" class="text-primary">2.0</span>
                </div>
            </div>

            <ul class="navbar-nav ml-auto">
                <base-dropdown
                    tag="li"
                    title-tag="a"
                    class="nav-item"
                    title-classes="nav-link"
                    menu-classes="dropdown-navbar"
                >
                    <template slot="title">
                        <div class="photo"><img :src="avatar" /></div>
                        <b class="caret d-none d-lg-block d-xl-block"></b>
                        <p class="d-lg-none">{{ $t('auth.my-account') }}</p>
                    </template>

                    <li class="nav-link">
                        <router-link to="/xlrs/my-account" class="nav-item dropdown-item">
                            {{ $t('auth.my-account') }}
                        </router-link>
                    </li>

                    <li class="nav-link" v-if="!$auth.user.owner">
                        <router-link to="/xlrs/owners" class="nav-item dropdown-item">
                            {{ $t('stores.exit-store') }}
                        </router-link>
                    </li>

                    <li class="nav-link">
                        <logout-link></logout-link>
                    </li>

                </base-dropdown>
            </ul>

        </base-nav>
    </div>
</template>

<script>
    import { CollapseTransition } from 'vue2-transitions';
    import BaseNav from '@tim/black-pro/src/components/Navbar/BaseNav.vue';
    import LogoutLink from '../../components/Auth/LogoutLink';

    export default {

        components: {
            CollapseTransition, BaseNav, LogoutLink
        },

        props: {
            avatar: {
                type: String,
                default: baseURL + '/img/anime3.png'
            }
        },

        methods: {

            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
            }
        }
    };
</script>

<style scoped>
    .top-navbar {
        top: 0px;
    }
</style>